import React, { useState } from "react";
import { DescriptionCheckbox } from "../../input/DescriptionCheckbox";
import { ProcessingRegion as ProcessingRegionEnum } from "../../../../common/service/server/dto/OrganizationDataRecipientDto";
import { Tooltip } from "@mui/material";
import { usePrimaryOrganization } from "../../../hooks";

type ProcessingRegionsSettingProps = {
  processingRegions: ProcessingRegionEnum[];
  updateState: (update: ProcessingRegionEnum[]) => void;
};
// This is the Stay Compliant variant of the processing region settings.
export const ProcessingRegionsSetting = ({
  processingRegions,
  updateState,
}: ProcessingRegionsSettingProps) => {
  const [organization] = usePrimaryOrganization();
  const [usChecked, setUsChecked] = useState<boolean>(processingRegions.includes("UNITED_STATES"));
  const [eeaChecked, setEeaChecked] = useState<boolean>(processingRegions.includes("EEA_UK"));
  const [canadaChecked, setCanadaChecked] = useState<boolean>(processingRegions.includes("CANADA"));

  const updateProcessingRegions = async (region: ProcessingRegionEnum, checked: boolean) => {
    if (checked) {
      if (!processingRegions.some((r) => r == region)) {
        processingRegions.push(region);
      }
    } else {
      processingRegions = processingRegions.filter((r) => r !== region);
    }
    updateState(processingRegions);
  };

  return (
    <div className="ml-xxs flex-row align-items-center">
      <DescriptionCheckbox
        label={
          <Tooltip title="US">
            <img src="/assets/images/flag-usa-small.png" alt="US" width="40" height="25" />
          </Tooltip>
        }
        checked={usChecked}
        onChange={(e, checked) => {
          setUsChecked(checked);
          return updateProcessingRegions("UNITED_STATES", checked);
        }}
      />
      {organization && organization.featureGdpr && (
        <DescriptionCheckbox
          label={
            <Tooltip title="EEA/UK/CH">
              <img src="/assets/images/flag-eea.svg" alt="EEA/UK/CH" width="40" height="26" />
            </Tooltip>
          }
          checked={eeaChecked}
          onChange={(e, checked) => {
            setEeaChecked(checked);
            return updateProcessingRegions("EEA_UK", checked);
          }}
        />
      )}
      {organization && organization.featurePipeda && (
        <DescriptionCheckbox
          label={
            <Tooltip title="Canada">
              <img src="/assets/images/flag-canada.svg" alt="Canada" width="40" height="26" />
            </Tooltip>
          }
          checked={canadaChecked}
          onChange={(e, checked) => {
            setCanadaChecked(checked);
            return updateProcessingRegions("CANADA", checked);
          }}
        />
      )}
    </div>
  );
};
